import { CardClickPopupType } from '@colonist/game-card-types';
import { CardEnum, CardTypeEnum, TurnState } from '@colonist/game-states';
export function getDevelopmentCardData() {
    return [
        {
            cardEnum: CardEnum.DevelopmentBack,
            cardTypeEnum: CardTypeEnum.Development,
            isCardBack: true,
            clickPopupType: CardClickPopupType.None,
            allowableTurnStates: undefined
        },
        {
            cardEnum: CardEnum.Knight,
            cardTypeEnum: CardTypeEnum.Development,
            isCardBack: false,
            clickPopupType: CardClickPopupType.ConfirmationPopup,
            allowableTurnStates: [
                TurnState.Turn,
                TurnState.Dice
            ]
        },
        {
            cardEnum: CardEnum.VictoryPoint,
            cardTypeEnum: CardTypeEnum.Development,
            isCardBack: false,
            clickPopupType: CardClickPopupType.ConfirmationPopup,
            allowableTurnStates: undefined
        },
        {
            cardEnum: CardEnum.Monopoly,
            cardTypeEnum: CardTypeEnum.Development,
            isCardBack: false,
            clickPopupType: CardClickPopupType.NormalClick,
            allowableTurnStates: [
                TurnState.Turn,
                TurnState.Dice
            ]
        },
        {
            cardEnum: CardEnum.RoadBuilding,
            cardTypeEnum: CardTypeEnum.Development,
            isCardBack: false,
            clickPopupType: CardClickPopupType.ConfirmationPopup,
            allowableTurnStates: [
                TurnState.Turn,
                TurnState.Dice
            ]
        },
        {
            cardEnum: CardEnum.YearOfPlenty,
            cardTypeEnum: CardTypeEnum.Development,
            isCardBack: false,
            clickPopupType: CardClickPopupType.NormalClick,
            allowableTurnStates: [
                TurnState.Turn,
                TurnState.Dice
            ]
        }
    ];
}
export function isDevelopmentCard(cardEnum) {
    return getDevelopmentCardData().some((cardData)=>cardData.cardEnum == cardEnum);
}
